// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__1UH6_","label":"Category_label__1Z6b3","content":"Category_content__1c7iI","header":"Category_header__3u20r","location":"Category_location__ULEP6"};